// SEQ-180 phase 2: the metric vocabulary's SHAPE, with no supabase import.
//
// Split out of usePnlMetricRegistry.ts for the same reason
// pnlCalculationCore.ts was split out of the P&L service: Deno's type checker
// resolves a type's whole declaration file, and usePnlMetricRegistry.ts
// imports src/lib/supabase.ts, which reads `import.meta.env`. Anything a Deno
// test needs to type against therefore lives here instead.

import type { PnlMetricDefinition } from "../../lib/pnl/pnlAnalytics";

export interface PnlMetricOption extends PnlMetricDefinition {
  displayName: string;
  sortOrder: number;
  /** True for a row this organisation created, false for a system row. */
  isCustom: boolean;
}

/** "labour.overtime_hours" reads as "Overtime hours", used only when the registry table is unreachable. */
export function humaniseMetricKey(metricKey: string): string {
  const leaf = metricKey.split(".").slice(1).join(" ") || metricKey;
  const words = leaf.replace(/_/g, " ").trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
}
